var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple__block" }, [
        _c("div", { staticClass: "order__block_info" }, [
          _c("p", [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.formatText(
                    _vm.get_translation_constant("text_tracking_number_full")
                  )
                ) + ":"
              ),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "order__traking_number",
                attrs: { href: "javascript:void(0)" },
              },
              [_vm._v(_vm._s(_vm.parcel.track_code))]
            ),
            _c("span", { staticClass: "copy__traking_number" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M5.89 18h6.18c1.25 0 1.9-.67 1.9-1.96V15h1.12c1.26 0 1.91-.67 1.91-1.98V7.45c0-.79-.16-1.3-.62-1.78l-2.89-3.03A2.1 2.1 0 0011.86 2H8.93c-1.25 0-1.9.68-1.9 1.99v1.08H5.9C4.65 5.07 4 5.75 4 7.04v9c0 1.3.65 1.96 1.89 1.96zm8.07-7.35c0-.8-.1-1.18-.58-1.7l-3.14-3.28c-.47-.49-.87-.6-1.58-.6H8.2V4.01c0-.53.26-.82.8-.82h2.95v2.94c0 .75.39 1.13 1.1 1.13h2.8V13c0 .54-.26.82-.8.82h-1.08v-3.17zm-.78-4.37c-.2 0-.28-.1-.28-.3V3.42l2.74 2.87h-2.46zM5.98 16.8c-.54 0-.82-.3-.82-.85V7.1c0-.54.28-.85.83-.85h2.46v3.25c0 .86.41 1.28 1.25 1.28h3.1v5.17c0 .55-.27.85-.83.85H6zm3.83-7.06c-.24 0-.34-.1-.34-.36V6.42l3.18 3.33H9.81z",
                      fill: "#06C",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "copy__traking_alert" }, [
                _vm._v(
                  _vm._s(
                    _vm.get_translation_constant("text_copied_to_clipboard")
                  )
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("label", [
              _vm._v(_vm._s(_vm.formatText(_vm.getDateText)) + ":"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.getParcelDate))]),
          ]),
          _vm._v(" "),
          typeof _vm.parcel.market_link !== "undefined"
            ? _c("p", [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.formatText(_vm.get_translation_constant("text_shop"))
                    ) + ":"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "order__shop_link",
                    attrs: { href: _vm.parcel.market_link },
                  },
                  [_vm._v(_vm._s(_vm.parcel.market.title))]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "order__print" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M6.11 17.76h.74v.82c0 .99.46 1.42 1.36 1.42h7.58c.9 0 1.36-.43 1.36-1.42v-.82h.75c1.37 0 2.1-.72 2.1-2.17V8.65c0-1.43-.73-2.17-2.1-2.17h-.7V6.1c0-1.45-.7-2.09-2-2.09H8.8c-1.23 0-2 .64-2 2.09v.4h-.69C4.8 6.48 4 7.21 4 8.64v6.94c0 1.45.73 2.17 2.11 2.17zm1.8-11.75c0-.62.3-.93.89-.93h6.4c.6 0 .9.3.9.93v.47H7.9v-.47zM6.1 16.65c-.63 0-.96-.35-.96-1V8.59c0-.65.33-1 .96-1H17.9c.62 0 .95.35.95 1v7.06c0 .65-.33 1-.95 1h-.76V12.2c0-.98-.46-1.41-1.36-1.41H8.21c-.85 0-1.36.43-1.36 1.41v4.45H6.1zm2.46 2.24c-.37 0-.57-.2-.57-.6v-5.8c0-.4.2-.58.57-.58h6.89c.38 0 .56.18.56.58v5.8c0 .4-.18.6-.56.6H8.56zm.99-4.31h4.92c.25 0 .44-.2.44-.47a.43.43 0 00-.44-.45H9.55c-.26 0-.45.2-.45.45 0 .27.2.47.45.47zm0 2.58h4.92c.25 0 .44-.2.44-.45 0-.26-.19-.46-.44-.46H9.55c-.26 0-.45.2-.45.46 0 .25.2.45.45.45z",
                    fill: "#515154",
                  },
                }),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        typeof _vm.parcel.products !== "undefined" && _vm.parcel.products.length
          ? _c("div", { staticClass: "order__block_list" }, [
              _c("h3", { staticClass: "h_text" }, [
                _vm._v(
                  _vm._s(_vm.get_translation_constant("text_product_list"))
                ),
              ]),
              _vm._v(" "),
              _c("table", { staticClass: "table table__order_item" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant("text_nomenclature")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant(
                            "text_additional_services"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.get_translation_constant("text_quantity"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.get_translation_constant("text_price"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.get_translation_constant("text_total"))
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.parcel.products, function (product, key) {
                    return _c("tr", [
                      _c("td", [
                        _c("a", { attrs: { href: "#" } }, [
                          _vm._v(_vm._s(product.name)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "table__extras d-flex justify-content-sm-end justify-content-lg-start align-items-center",
                          },
                          _vm._l(
                            _vm.parcel.services,
                            function (service, service_index) {
                              return _c(
                                "span",
                                {
                                  staticClass:
                                    "tooltip__block tooltip__top tooltip__block_simple",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "tooltip__block_trigger" },
                                    [
                                      _c("img", {
                                        staticClass: "service-image",
                                        attrs: { src: service.icon, alt: "" },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "tooltip__block_inner" },
                                    [_c("p", [_vm._v(_vm._s(service.title))])]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [_vm._v(_vm._s(product.qty) + " х")]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [_vm._v(_vm._s(product.price) + " $")]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(
                            _vm._s((product.price * product.qty).toFixed(2)) +
                              " $"
                          ),
                        ]),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-4" }, [
                _c("div", { staticClass: "col-12 col-md-6" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6 text-md-end" }, [
                  _c("div", { staticClass: "packages__total_price" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.get_translation_constant(
                            "text_total_products_price"
                          )
                        ) +
                        ":\n                            "
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.totalProductPrice))]),
                    _vm._v(" $\n                        "),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.parcel.parent_id === null &&
              _vm.parcel.declared &&
              _vm.parcel.parcel_tracking_status_id < 3
                ? _c("div", { staticClass: "d-md-flex justify-content-end" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn__large btn__blue_link d-block",
                        attrs: { href: _vm.parcel.edit_parcel_link },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.get_translation_constant("text_edit"))
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ])
          : _c("div", { staticClass: "order__block_list" }, [
              _vm.parcel.parent_id === null && _vm.parcel.declared
                ? _c("div", { staticClass: "d-md-flex justify-content-end" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn__large btn__blue_link d-block",
                        attrs: { href: _vm.parcel.edit_parcel_link },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.get_translation_constant("text_edit"))
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alert_files !== "",
              expression: "alert_files !== ''",
            },
          ],
          staticClass: "alert__block",
        },
        [
          _c("div", { staticClass: "alert__block_header" }, [
            _c("h3", { staticClass: "h_text" }, [
              _vm._v(
                _vm._s(_vm.get_translation_constant("text_files_not_accepted"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "alert__block_close",
                on: {
                  click: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "p",
                        undefined,
                        $event.key,
                        undefined
                      )
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.clearAlertFiles.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M7.1 17.34a.73.73 0 000 1.02c.28.27.74.27 1.02 0l4.66-4.66 4.66 4.66c.28.27.75.28 1.02 0a.74.74 0 000-1.02l-4.66-4.67 4.66-4.65a.73.73 0 000-1.03.74.74 0 00-1.02 0l-4.66 4.67-4.66-4.67a.73.73 0 00-1.03 0 .73.73 0 000 1.02l4.67 4.66-4.67 4.67z",
                        fill: "#000",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.alert_files, function (file, key) {
            return _c("p", [_vm._v(_vm._s(file))])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("file-upload", {
        attrs: {
          files_array: _vm.files,
          multiple: true,
          translations: _vm.translations,
          ajax: true,
          lng: _vm.lng,
          upload_files_link: _vm.upload_files_link,
          delete_files_link: _vm.delete_files_link,
          additional_ajax_params: { parcel_id: _vm.parcel.id },
          downloadlink: _vm.downloadlink,
        },
        on: {
          childToParentAlert: function ($event) {
            return _vm.setAlertData($event, "alert_files")
          },
        },
      }),
      _vm._v(" "),
      _vm.parcel.pictures.length
        ? _c(
            "div",
            { staticClass: "simple__block mt-4" },
            [
              _c("file-upload", {
                ref: "fileUpload",
                attrs: {
                  files_array: _vm.serverPictures,
                  multiple: true,
                  translations: _vm.translations,
                  ajax: false,
                  lng: _vm.lng,
                  upload_files_link: _vm.upload_files_link,
                  delete_files_link: _vm.delete_files_link,
                  additional_ajax_params: { parcel_id: _vm.parcel.id },
                  downloadlink: _vm.downloadlink,
                  template: "preview-photo",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }